import cbx from './cbx.json';
import common from './common.json';

const de = {
  ...common,
  cbx,
};

export default de;
